(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.directive('userCard', [UserCardFn]);

    /* user card directive */
    function UserCardFn() {

        var directive = {
            restrict: 'E',
            //replace: true,
            scope: {
                user: '='
            },
            templateUrl: '/app/users/templates/user-card.template.html',
            controller: 'UserCardController',
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };
        return directive;

        function link(scope, element) {
            //var el = element.find('#contactinfos');
            //// slim scroll
            //if (el) {
            //    el.slimScroll({ height: '50%' }); // 100 % viewport height 
            //}


        }
    }
})();